export enum AnnouncementStyle {
    SUCCESS = 'SUCCESS',
    WARNING = 'WARNING',
    DANGER = 'DANGER',
    CUSTOM = 'CUSTOM',
}
